import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=61fb3b92&t=2"
import script from "./Index.vue?vue&type=script&lang=js&t=2"
export * from "./Index.vue?vue&type=script&lang=js&t=2"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports